import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { EdgeState } from './edge.types';

import { EdgeModel } from '~/core/models';

const initialState: EdgeState = {
  isApplySameEdgeActive: true,
};

const edgeSlice = createSlice({
  name: 'edge',
  initialState,
  reducers: {
    updateApplySameEdge: (state, action: PayloadAction<boolean>) => {
      state.isApplySameEdgeActive = action.payload;
    },
    updateUserSelectedEdge: (
      state,
      action: PayloadAction<EdgeModel | undefined>
    ) => {
      state.userSelectedEdge = action.payload;
    },
    resetSelectedEdge: (state) => {
      state.userSelectedEdge = undefined;
    },
  },
});

export const {
  updateApplySameEdge,
  updateUserSelectedEdge,
  resetSelectedEdge,
} = edgeSlice.actions;

export default edgeSlice.reducer;
